// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__fwbrm","mobile":"style_mobile__dqz7N","laptop":"style_laptop__aIEiG","v3":"style_v3__0rxSj"};